import { defineStore } from 'pinia';
import FollowUpsAPI from 'dashboard/api/followUps';

export const useFollowUpsStore = defineStore('followUps', {
  state: () => ({
    groups: {
      overdue: [],
      today: [],
      this_week: [],
      upcoming: [],
    },
    isFetching: false,
  }),

  getters: {
    totalCount: state =>
      state.groups.overdue.length +
      state.groups.today.length +
      state.groups.this_week.length +
      state.groups.upcoming.length,
  },

  actions: {
    async fetchFollowUps(params = {}) {
      this.isFetching = true;
      try {
        const { data } = await FollowUpsAPI.get(params);
        this.groups = data;
      } finally {
        this.isFetching = false;
      }
    },

    async createFollowUp(payload) {
      const { data } = await FollowUpsAPI.create(payload);
      this._addToGroup(data);
      return data;
    },

    async updateFollowUp(id, payload) {
      const { data } = await FollowUpsAPI.update(id, payload);
      this._removeFromGroups(id);
      this._addToGroup(data);
      return data;
    },

    async markDone(id) {
      await FollowUpsAPI.markDone(id);
      this._removeFromGroups(id);
    },

    async cancelFollowUp(id) {
      await FollowUpsAPI.cancel(id);
      this._removeFromGroups(id);
    },

    _addToGroup(followUp) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const scheduled = new Date(followUp.scheduled_for + 'T00:00:00');
      const endOfWeek = new Date(today);
      endOfWeek.setDate(today.getDate() + (6 - today.getDay()));

      if (scheduled < today) {
        this.groups.overdue.push(followUp);
      } else if (scheduled.getTime() === today.getTime()) {
        this.groups.today.push(followUp);
      } else if (scheduled <= endOfWeek) {
        this.groups.this_week.push(followUp);
      } else {
        this.groups.upcoming.push(followUp);
      }
    },

    _removeFromGroups(id) {
      for (const key of Object.keys(this.groups)) {
        this.groups[key] = this.groups[key].filter(f => f.id !== id);
      }
    },
  },
});
